import easyIcon from '../assets/images/advantages-icon-0.svg';
import seamlessIcon from '../assets/images/advantages-icon-1.svg';
import alwaysIcon from '../assets/images/advantages-icon-2.svg';

const advantagesItemsData = [
    {
        icon: easyIcon,
        title: 'Easy to Use',
        text: 'Made with a simple, professional and powerful user interface that enhance user experience and is user friendly for everyone.',
    },

    {
        icon: seamlessIcon,
        title: 'Seamless Architecture',
        text: 'Engineered with the best and latest coding technologies and frameworks to ensure seamless, fast and lag free experience.',
    },

    {
        icon: alwaysIcon,
        title: 'Always on the Go',
        text: 'Developed for both PC and Mobile for users to access it anytime and anywhere.',
    },
];

const getAdvantagesItemsData = () => advantagesItemsData;

export default getAdvantagesItemsData;
